module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-3-3.d5ebb4fa.png";